import { PromptObjectInputSpeakAs } from '../../types';

export const speakAsOptions = [
  {
    value: PromptObjectInputSpeakAs.addressCity,
    name: 'Address City',
    defaultValue: 'Franklin'
  },
  {
    value: PromptObjectInputSpeakAs.addressStreet,
    name: 'Address Street',
    defaultValue: 'Hayward St'
  },
  {
    value: PromptObjectInputSpeakAs.asIs,
    name: 'As Is',
    defaultValue: 'as is'
  },
  {
    value: PromptObjectInputSpeakAs.character,
    name: 'Character',
    defaultValue: 'I'
  },
  {
    value: PromptObjectInputSpeakAs.company,
    name: 'Company',
    defaultValue: 'Interactions'
  },
  {
    value: PromptObjectInputSpeakAs.currency,
    name: 'Currency',
    defaultValue: '$1.00'
  },
  {
    value: PromptObjectInputSpeakAs.date,
    name: 'Date',
    defaultValue: 'January 1, 2020'
  },
  {
    value: PromptObjectInputSpeakAs.digit,
    name: 'Digit',
    defaultValue: '1'
  },
  {
    value: PromptObjectInputSpeakAs.internet,
    name: 'Internet',
    defaultValue: '@interactions.com'
  },
  {
    value: PromptObjectInputSpeakAs.name,
    name: 'Name',
    defaultValue: 'Jane Doe'
  },
  {
    value: PromptObjectInputSpeakAs.number,
    name: 'Number',
    defaultValue: '12345'
  },
  {
    value: PromptObjectInputSpeakAs.phoneNumber,
    name: 'Phone Number',
    defaultValue: '123-456-7890'
  },
  {
    value: PromptObjectInputSpeakAs.phoneticSpelling,
    name: 'Phonetic Spelling',
    defaultValue: 'I as in Interactions'
  },
  {
    value: PromptObjectInputSpeakAs.phoneticWord,
    name: 'Phonetic Word',
    defaultValue: 'dog'
  },
  {
    value: PromptObjectInputSpeakAs.phrase,
    name: 'Phrase',
    defaultValue: 'This is a phrase'
  },
  {
    value: PromptObjectInputSpeakAs.spelling,
    name: 'Spelling',
    defaultValue: 'I n t e r a c t i o n s'
  },
  {
    value: PromptObjectInputSpeakAs.time,
    name: 'Time',
    defaultValue: '5pm'
  },
  {
    value: PromptObjectInputSpeakAs.translationCode,
    name: 'Translation Code',
    defaultValue: '12345'
  },
  {
    value: PromptObjectInputSpeakAs.word,
    name: 'Word',
    defaultValue: 'dog'
  }
];
